var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFilterTypeVideo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    fill: "none",
    viewBox: "0 0 14 14",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#323657",
    d: "M8.993 5.76 6.368 4.01a.437.437 0 0 0-.68.365v3.5a.437.437 0 0 0 .68.364l2.625-1.75a.438.438 0 0 0 0-.728m-2.43 1.297V5.195l1.398.93zm5.25-4.87H2.188a.875.875 0 0 0-.876.876v6.124a.875.875 0 0 0 .876.876h9.625a.875.875 0 0 0 .874-.876V3.064a.875.875 0 0 0-.874-.876m0 7H2.188V3.064h9.625zm.874 2.188a.44.44 0 0 1-.437.438H1.75a.438.438 0 0 1 0-.876h10.5a.44.44 0 0 1 .438.438"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterTypeVideo);
export default __webpack_public_path__ + "static/media/filter-type-video.d7edee9e1043d1520345d0931b7b6ca2.svg";
export { ForwardRef as ReactComponent };